import { inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/messages';

const validate = (values) =>{
    const error = {};

    if (!values.itemName) {
        error.itemName = messages.required;
    } else if(values.itemName && values.itemName.toString().trim() === '') {
        error.itemName = messages.required;
    } else if (values.itemName.length > inputTextLimit) {
        error.itemName = messages.inputTextLimitError;
    }

    return error;
}

export default validate;